import React from 'react';
import PropTypes from 'prop-types'; // ES6
import { Input } from 'antd';

import PopoverError from '../commons/popoverError';

const { TextArea } = Input;

const AvisIntroduccioSeccioDadesMeteorCampText = (props) => {
    const { camp, onModificarValor } = props;
    const { nom, error, id, valor } = camp;

    const errorRenderitzat = (error) ? <PopoverError contingut='Camp obligatori' /> : null;

    return (
        <div className='avis-introduccio-seccio-dades-meteor-camp-text' >
            <span className='titol'>
                {nom}:
            </span>
            <TextArea
                autosize={{ minRows: 2, maxRows: 1 }}
                onChange={(event) => {onModificarValor(id, event.target.value);}}
                value={ valor } />
            {errorRenderitzat}
        </div>
    );
};

AvisIntroduccioSeccioDadesMeteorCampText.propTypes = {
    camp: PropTypes.object.isRequired,
    onModificarValor: PropTypes.func.isRequired
};

export default AvisIntroduccioSeccioDadesMeteorCampText;



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteorCampText.js